/**
 * Create filters string to pass as parameter:
 *
 * @param {Array} searchBoxFilters - Array. Properties name to search and compare with searchBox value.
 * @param {Array} otherFilters - Array. Other properties name to search but not with searchBox value.
 * @param {Array} rangeFilters - Array. Range filters that has a Start value and an End value.
 * @param {Object} searchValues - Object. Selected filters values.
 *
 * @returns {Array}
 */
export default (searchBoxFilters, otherFilters, rangeFilters, searchValues) => {
  const filtersArray = [];
  if (typeof searchValues.searchBox !== 'undefined' && searchValues.searchBox) {
    searchBoxFilters.forEach((filterBy, index) => {
      if (filterBy !== 'mobilePhoneNumber' || !isNaN(searchValues.searchBox)) {
        filtersArray.push({
          filterBy,
          filterValue: searchValues.searchBox,
          group: index,
        });

        filtersArray.push(
          otherFilters
            .filter(
              ({ keyName }) =>
                searchValues[keyName] !== null &&
                typeof searchValues[keyName] !== 'undefined' &&
                searchValues[keyName] !== ''
            )
            .map(({ keyName, operator: op = null }) => {
              const filterValue =
                typeof searchValues[keyName] === 'object' &&
                !Array.isArray(searchValues[keyName])
                  ? searchValues[keyName]?.value
                  : searchValues[keyName];
              const operator =
                typeof searchValues[keyName] === 'object' &&
                !Array.isArray(searchValues[keyName]) &&
                Object.hasOwn(searchValues[keyName], 'operator')
                  ? searchValues[keyName]?.operator
                  : op;
              return {
                filterBy: keyName,
                filterValue,
                operator,
                group: index,
              };
            })
        );

        filtersArray.push(
          rangeFilters //range value in searchBox needs to be a 2 elements array [MIN, MAX]
            .filter(
              ({ keyName }) =>
                searchValues[keyName] !== null &&
                typeof searchValues[keyName] !== 'undefined' &&
                searchValues[keyName] !== ''
            )
            .map(({ keyName, includeExtremes }) => [
              {
                filterBy: keyName,
                filterValue: searchValues[keyName][0], //element in position 0
                operator: includeExtremes ? '!lt' : 'gt',
                group: index,
              },
              {
                filterBy: keyName,
                filterValue: searchValues[keyName][1], //element in position 0
                operator: includeExtremes ? '!gt' : 'lt',
                group: index,
              },
            ])
        );
      }
    });
    return filtersArray.flat(2);
  }
  //if no searchBox values
  filtersArray.push(
    otherFilters
      .filter(
        ({ keyName }) =>
          searchValues[keyName] !== null &&
          typeof searchValues[keyName] !== 'undefined' &&
          searchValues[keyName] !== ''
      )
      .map(({ keyName, operator: op = null }) => {
        const filterValue =
          typeof searchValues[keyName] === 'object' &&
          !Array.isArray(searchValues[keyName])
            ? searchValues[keyName]?.value
            : searchValues[keyName];
        const operator =
          typeof searchValues[keyName] === 'object' &&
          !Array.isArray(searchValues[keyName]) &&
          Object.hasOwn(searchValues[keyName], 'operator')
            ? searchValues[keyName]?.operator
            : op;
        return {
          filterBy: keyName,
          filterValue,
          operator,
          group: 0,
        };
      })
  );

  filtersArray.push(
    rangeFilters //range value in searchBox needs to be a 2 elements array [MIN, MAX]
      .filter(
        ({ keyName }) =>
          searchValues[keyName] !== null &&
          typeof searchValues[keyName] !== 'undefined' &&
          searchValues[keyName] !== ''
      )
      .map(({ keyName, includeExtremes }) => [
        {
          filterBy: keyName,
          filterValue: searchValues[keyName][0], //element in position 0
          operator: includeExtremes ? '!lt' : 'gt',
          group: 0,
        },
        {
          filterBy: keyName,
          filterValue: searchValues[keyName][1], //element in position 0
          operator: includeExtremes ? '!gt' : 'lt',
          group: 0,
        },
      ])
  );

  return filtersArray.flat(2);
};
